import React from 'react'

import {
    paletaCores6,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import mapaFinanceiroItemList from '../../../business-rules/List/mapaFinanceiroItemList'



const MapaFinanceiroChart = ( { values, report } ) => {

    const series = []

    let dataIdeal = []
    let dataAtual = []
    let categoriesMapaFinanceiro = []

    values.mapaFinanceiro?.forEach( (linhaMapaFinanceiro, index) => {

        dataIdeal.push(HARDCODE.notaIdeal)
        dataAtual.push(linhaMapaFinanceiro.nota)
        categoriesMapaFinanceiro.push(pesquisaList(mapaFinanceiroItemList, linhaMapaFinanceiro.id).descricao)
    })

    series.push(
        {
            name: LABEL.ideal,
            data: dataIdeal,
        },
    )

    series.push(
        {
            name: LABEL.atual,
            data: dataAtual,
        },
    )

    const categories = categoriesMapaFinanceiro

    return (
        <ChartPadrao
            titleText={""}
            type={'radar'}
            series={series}
            categories={categories}
            paletaCores={paletaCores6}
            report={report}
            formatoReport={values.formatoReport}
            height={420}
            fillType={'unfilled'}
            //legendHorizontalAlign={'center'}
            valorNumero={'N'}
            yaxisNullZero={true}
        />
    )
}

export default MapaFinanceiroChart